// extracted by mini-css-extract-plugin
export default {"versions":"bv_gJ","newsletterSignup":"bv_gK","announcement":"bv_gL"};